import { Link, useNavigate } from 'react-router-dom';
import { 
  LayoutDashboard, 
  FileText, 
  Briefcase, 
  BookOpen, 
  Mail, 
  LogOut,
  ClipboardList
} from 'lucide-react';

import { motion } from 'framer-motion';

const AdminDashboard = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/admin/login');
  };

const menuItems = [
  { icon: <FileText className="w-6 h-6" />, title: 'Blog Posts', link: '/admin/blog', color: 'bg-blue-500' },
  { icon: <Briefcase className="w-6 h-6" />, title: 'Projects', link: '/admin/projects', color: 'bg-green-500' },
  { icon: <BookOpen className="w-6 h-6" />, title: 'Careers', link: '/admin/careers', color: 'bg-purple-500' },

  {
    icon: <ClipboardList className="w-6 h-6" />,
    title: 'Applications',
    link: '/admin/applications',
    color: 'bg-indigo-500'
  },

  {
    icon: <LayoutDashboard className="w-6 h-6" />,
    title: 'User Management',
    link: '/admin/usermanagement',
    color: 'bg-orange-500'
  },

  { icon: <Mail className="w-6 h-6" />, title: 'Contact Submissions', link: '/admin/contact', color: 'bg-pink-500' },
];



  return (
    <div className="min-h-screen bg-slate-50">
      <nav className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <h1 className="text-2xl font-heading font-bold text-gradient">CodeSky Admin</h1>
            <button
              onClick={handleLogout}
              className="flex items-center space-x-2 text-slate-600 hover:text-primary transition-colors"
              data-testid="logout-button"
            >
              <LogOut className="w-5 h-5" />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-6 py-12">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="mb-12">
          <h2 className="text-4xl font-heading font-bold text-slate-900 mb-2">Dashboard</h2>
          <p className="text-slate-600">Manage your website content</p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {menuItems.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <Link to={item.link}>
                <div className="bg-white rounded-xl p-6 hover:shadow-lg transition-all duration-300 group" data-testid={`admin-card-${index}`}>
                  <div className={`${item.color} w-12 h-12 rounded-lg flex items-center justify-center text-white mb-4 group-hover:scale-110 transition-transform`}>
                    {item.icon}
                  </div>
                  <h3 className="text-xl font-heading font-bold text-slate-900">{item.title}</h3>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
